<template>
  <div>
    <!-- 订单状态列表 -->
    <el-dialog :visible.sync="dialogVisible" width="1200px" :title="title">
      <div class="table">
        <ol>
          <!-- 配送单号 -->
          <li v-if="type == 4">
            {{ $t('message.deliveryNoteNumber') }}
          </li>
          <!-- 订单号 -->
          <li>
            {{ $t('message.orderNumber') }}
          </li>
          <!-- 番号 -->
          <li class="flex05">
            {{ $t('message.mash') }}
          </li>
          <!-- 商品图片 -->
          <li>
            {{ $t('message.productPicture') }}
          </li>
          <!-- 购买数量 -->
          <li v-if="type > 3">
            {{ $t('message.PurchaseQuantity') }}
          </li>
          <!-- 附加服务 -->
          <li>
            {{ $t('message.additionalServices') }}
          </li>
          <!-- 标签信息 -->
          <li>
            {{ $t('message.tagInformation') }}
          </li>
          <!-- 单番备注 -->
          <li>
            {{ $t('message.singleNote') }}
          </li>
          <!-- 购买数量 -->
          <li v-if="type == 1">
            {{ $t('message.PurchaseQuantity') }}
          </li>
          <!-- 在库数量 -->
          <li v-if="type == 2">
            {{ $t('message.stockNumber') }}
          </li>
          <!-- 进行中数量 -->
          <li v-if="type == 3">
            {{ $t('message.number') }}
          </li>
          <!-- 出货数量 -->
          <li v-if="type == 4">
            {{ $t('message.ShipmentQuantity') }}
          </li>
        </ol>
        <ul v-for="(item, index) in list" :key="index">
          <!-- 配送单号 -->
          <li v-if="type == 4">
            <router-link :to="'/porderDetail?porder_sn=' + item.porder_sn" target="_blank" class="a-link">
              {{ item.porder_sn }}
            </router-link>
          </li>
          <!-- 订单号 -->
          <li>
            <router-link :to="'/oederDetai?order_sn=' + item.order_sn" target="_blank" class="a-link">
              {{ item.order_sn }}
            </router-link>
          </li>
          <!-- 番号 -->
          <li class="flex05">
            {{ item.sorting }}
          </li>
          <!-- 商品图片 -->
          <li>
            <el-image style="width:80px;height: 80px;border-radius: 6px;" :src="item.pic"
              :preview-src-list="[item.pic]">
            </el-image>
          </li>
          <!-- 购买数量 -->
          <li v-if="type > 3">
            {{ item.confirm_num }}
          </li>
          <!-- 附加服务 -->
          <li>
            <div class="option">
              <el-popover placement="bottom" width="160" trigger="hover">
                <p v-for="(items, indexs) in item.option" :key="indexs">
                  {{ indexs + 1 }}) {{ items.name }}
                </p>
                <div slot="reference">
                  <p v-for="(items, indexs) in item.option" :key="indexs">
                    {{ indexs + 1 }}) {{ items.name }}
                  </p>
                </div>
              </el-popover>
            </div>
          </li>
          <!-- 标签信息 -->
          <li>
            <div class="order_detail_tag">
              <div v-for="(tag, tagIndex) in item.order_detail_tag" :key="tagIndex">
                <p>类别:{{ tag.type }}</p>
                <p>标签号:{{ tag.no }}</p>
                <p>商品码:{{ tag.goods_no }}</p>
              </div>
            </div>
          </li>
          <!-- 单番备注 -->
          <li>
            {{ item.client_remark }}
          </li>
          <!-- 购买数量 -->
          <li v-if="type == 1" class="bgc">
            {{ item.confirm_num }}
          </li>
          <!-- 在库数量 -->
          <li v-if="type == 2" class="bgc">
            {{ item.num }}
          </li>
          <!-- 进行中数量 -->
          <li v-if="type == 3" class="bgc">
            {{ item.num }}
          </li>
          <!-- 出货数量 -->
          <li v-if="type == 4" class="bgc">
            {{ item.num }}
          </li>
        </ul>
        <div class="nodata" v-if="list == false">暂无数据</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: '',
      dialogVisible: false,
      list: [],
      type: '',
    };
  },
  methods: {
  }
}
</script>
<style lang='scss' scoped>
.table {
  padding: 30px;
  max-height: 600px;
  overflow-y: auto;

  li {
    justify-content: left;
    padding: 0 15px;
    position: relative;
  }

  .flex3 {
    flex: 3;
  }

  .flex05 {
    flex: 0.5;
  }

  ol {
    height: 42px;
  }

  ul {
    background-color: #fff;
    min-height: 100px;
    padding: 5px 0;

    .template {
      display: flex;
      line-height: 36px;
    }

    .option {
      height: 100px;
      overflow: hidden;
    }

    /deep/.el-textarea__inner {
      height: 110px !important;
      width: 100% !important;
    }

    /deep/.el-upload-dragger {
      width: auto;
      height: auto;
      border: none;
    }

  }

  .file {
    width: 100%;

    .item {
      display: flex;
      width: 100%;
      margin-bottom: 10px;

      a {
        margin-right: 12px;
        flex: 1;
      }

      .el-icon-error {
        cursor: pointer;
        font-size: 16px;
        color: #B4272B;
        ;
      }
    }
  }

  .pic-box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .img {
      position: relative;
      width: 50px;
      margin-right: 5px;

      &:hover {
        .btn {
          display: flex;
        }
      }

      .btn {
        position: absolute;
        top: 0;
        left: 0;
        width: 50px;
        height: 50px;
        background-color: rgba(0, 0, 0, 0.2);
        display: none;
        justify-content: center;
        align-items: center;
        border-radius: 5px;

        i {
          color: #fff;
          font-size: 16px;
          cursor: pointer;

          &:nth-last-child(1) {
            margin-left: 10px;
          }
        }
      }

      video {
        width: 50px;
        height: 50px;
        border-radius: 5px;
      }

      img {
        width: 50px;
        height: 50px;
        border-radius: 5px;
      }
    }
  }

  .bgc {
    background-color: rgba(250, 205, 145, 0.584313725490196);
  }
}

.nodata {
  text-align: center;
  padding: 30px;
  font-size: 20px;
}

.operation {
  margin-top: 24px;
}
</style>